import { render } from "./SizingPage.vue?vue&type=template&id=dd12b45a&ts=true"
import script from "./SizingPage.vue?vue&type=script&lang=ts"
export * from "./SizingPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__